var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsFavouritesAndAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -971.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Favourites-and-alerts",
    transform: "translate(5026.000000, 971.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9051203,29 C13.8759829,30.661 12.5406854,32 10.8909048,32 C9.24112427,32 7.90582683,30.661 7.87668942,29 L7.87668942,29 Z M10.8910053,6 C10.9080859,6 10.9251664,6.004 10.9432517,6.004 C10.723214,7.588 11.3863414,9.18 12.7316862,10.136 L12.7316862,10.136 L15.1822434,11.878 L13.689202,16.363 L13.2260175,17.753 L14.4186421,18.612 C15.1701865,19.153 16.0573706,19.439 16.9847442,19.439 C17.9312078,19.439 18.8324582,19.144 19.5920405,18.583 L19.5920405,18.583 L19.6694054,18.525 L21.2820106,27 L0.5,27 L3.43685057,11.564 C4.38230947,8.35 7.35834484,6 10.8910053,6 Z M22.8642728,0 L24.7431337,5.91 L29.2262768,5.867 L29.2483811,5.867 C30.2722096,5.867 31.1804932,6.522 31.5,7.492 L26.440137,11.105 L27.861842,15.348 C28.188382,16.322 27.8427519,17.396 27.0068095,18 L21.9971835,14.319 L18.3951961,16.976 C17.9772248,17.285 17.4818888,17.439 16.9845432,17.439 C16.4982498,17.439 16.0109516,17.29 15.5969994,16.992 L17.5562394,11.108 L13.8999961,8.509 C13.0600347,7.911 12.7053621,6.841 13.0238642,5.863 L19.2512332,5.909 L19.2512332,5.91 L20.6066254,1.646 C20.9180944,0.666 21.8324064,0 22.8642728,0 Z",
    id: 26
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsFavouritesAndAlerts);
export default __webpack_public_path__ + "static/media/investments-favourites-and-alerts.e541e0cc.svg";
export { ForwardRef as ReactComponent };